import { ReactNode } from 'react';
import './Card.scss';

const Card = ({children} : {
    children: ReactNode
}) => {
    return (
        <div className='card component'>
            {children}
        </div>
    )
}

export default Card;